export const ASSOCIATES_REQUEST = "ASSOCIATES_REQUEST";
export const ASSOCIATES_SUCCESS = "ASSOCIATES_SUCCESS";
export const ASSOCIATES_FAIL = "ASSOCIATES_FAIL";

export const ASSOCIATES_CREATE_REQUEST = "ASSOCIATES_CREATE_REQUEST";
export const ASSOCIATES_CREATE_SUCCESS = "ASSOCIATES_CREATE_SUCCESS";
export const ASSOCIATES_CREATE_FAIL = "ASSOCIATES_CREATE_FAIL";

export const ASSOCIATES_UPDATE_REQUEST = "ASSOCIATES_UPDATE_REQUEST";
export const ASSOCIATES_UPDATE_SUCCESS = "ASSOCIATES_UPDATE_SUCCESS";
export const ASSOCIATES_UPDATE_FAIL = "ASSOCIATES_UPDATE_FAIL";
export const ASSOCIATES_UPDATE_EMPTY = "ASSOCIATES_UPDATE_EMPTY";

export const ASSOCIATES_DELETE_REQUEST = "ASSOCIATES_DELETE_REQUEST";
export const ASSOCIATES_DELETE_SUCCESS = "ASSOCIATES_DELETE_SUCCESS";
export const ASSOCIATES_DELETE_FAIL = "ASSOCIATES_DELETE_FAIL";
export const ASSOCIATES_DELETE_EMPTY = "ASSOCIATES_DELETE_EMPTY";
